import React, { useCallback, useEffect, useState } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';
import RangeDates from 'components/Analytics/RangeDates';
import moment from 'moment';
import { statuses } from '../List/Status';
import _ from 'lodash';

/**
 * 
 * @param {{
 *  open: boolean,
 *  handleHistoryOpen: React.MouseEventHandler,
 *  history: HistoryEvent[]
 * }} param0 
 * @returns 
 */
export default function History({ open = false, handleHistoryOpen, history: _history }) {
    const [history, setHistory] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [from, setFrom] = useState(null);
    const [until, setUntil] = useState(null);

    useEffect(() => {
        let copy = (_history ? _.cloneDeep(_history) : []);
        _.reverse(copy);
        setHistory(copy);
        setFiltered(copy);
    }, [_history]);

    useEffect(() => {
        let preFiltered = _.cloneDeep(filtered);

        if (from) {
            preFiltered = preFiltered.filter(f => new Date(f.statusAt).getTime() > from.valueOf());
        }

        if (until) {
            preFiltered = preFiltered.filter(f => new Date(f.statusAt).getTime() < until.valueOf());
        }

        if (!from && !until) {
            preFiltered = history;
        }

        setFiltered(preFiltered);
    }, [from, until]);
    
    /**
     * @param {'from' | 'until'} type 
     * @param {Date} value
     */
    const changeDateRange = (type, value) => {
        if (type === 'from') {
            setFrom(value);
        } else {
            setUntil(value)
        }
    };

    /**
     * @param {'from' | 'until'} type 
     */
    const handleChangeDate = (type) => {
        if (type === 'from') {
            setFrom(null);
        } else {
            setUntil(null);
        }
    };

    return (
        <Dialog
            title='HISTORY'
            open={open}
            onRequestClose={handleHistoryOpen}
            actions={[
                <FlatButton
                    label='Close'
                    primary={true}
                    onClick={handleHistoryOpen}
                />
            ]}
        >
            <div className='historyFilter'>
                <RangeDates
                    from={from}
                    until={until}
                    changeDateRange={changeDateRange}
                    handleChangeDate={handleChangeDate}
                />
            </div>
            <div id='historyList'>
                <Table
                    className='table'
                    fixedHeader
                    height='400px'
                >
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false} style={{ borderBottom: 'none' }}>
                        <TableHeaderColumn width='29%' style={{ padding: 0, height: '15px' }}>
                            Status
                        </TableHeaderColumn>
                        <TableHeaderColumn width='47%' style={{ padding: 0, height: '15px' }}>
                            By user
                        </TableHeaderColumn>
                        <TableHeaderColumn width='24%' style={{ padding: 0, height: '15px' }}>
                            Date
                        </TableHeaderColumn>
                    </TableHeader>
                    <TableBody 
                        displayRowCheckbox={false} 
                        className='historyList-body' 
                        showRowHover
                    >
                        {
                            (filtered || []).map(event => {
                                return (
                                    <TableRow key={event._id}>
                                        <TableRowColumn style={{ fontSize: '12px', width: '29%', padding: 0 }} >{statuses[event.status].chip}</TableRowColumn>
                                        <TableRowColumn style={{ fontSize: '12px', width: '47%', padding: 0 }} >{event.statusBy.email}</TableRowColumn>
                                        <TableRowColumn style={{ fontSize: '12px', width: '24%', padding: 0 }} >{moment(event.statusAt).format('DD.MM.YYYY hh:mm:ss').toString()}</TableRowColumn>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        </Dialog>
    );
}

/**
 * @typedef {Object} HistoryEvent
 * @property {string} _id
 * @property {string} status
 * @property {string} statusAt
 * @property {{ email: string }} statusBy
 */



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/History.jsx